import { pathJoin } from 'src/reducers/routing/utils'

export const createDriverManagementRouteMap = (prefix: string) => ({
  configuration: pathJoin(prefix)('configuration').chain,
  vehicle: pathJoin(prefix)('vehicle').chain,
  route: pathJoin(prefix)('route').chain,
  'service-log': pathJoin(prefix)('service-log').chain,
  'shift-planner': pathJoin(prefix)('shift-planner').chain,
})
